import { createFileRoute } from '@tanstack/react-router';
import { SEO } from '@/components/SEO';
import { EmotionalMomentsDemo } from '@/components/poc/EmotionalMomentsDemo';

function MomentsRoute() {
  return (
    <>
      <SEO
        title='Emotional moments POC'
        description='Temperature Check, receipt scan, and court-ready export as motion.'
        path='/poc/moments'
        noindex
      />
      <EmotionalMomentsDemo />
    </>
  );
}

export const Route = createFileRoute('/poc/moments')({
  component: MomentsRoute,
});
